import { render, staticRenderFns } from "./SingleQuickLink.vue?vue&type=template&id=8f1d8ea8"
import script from "./SingleQuickLink.vue?vue&type=script&lang=js"
export * from "./SingleQuickLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports